const fetchPrice = async (quantity, sku) => {
    let minimumAllowedMonths = 1;
    const response = await fetch("/.netlify/functions/calc?sku=" + sku + "&qty=" + quantity + "&months=" + minimumAllowedMonths, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
    })

    const data = await response.json();
    return { finalCost: data.result.finalCost, totalCost: data.result.totalCost }
}

const finalPrice = async (quantity, sku) => {
    let result = await fetchPrice(quantity, sku)
    return result
}

export const getPrice = (quantity, sku, cb) => {
    return finalPrice(quantity, sku).then(res => { 
        cb(res); 
        return res;
    });
}